import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modules: {},
  formData: {
    name: "",
    description: "",
    type: "",
  },
  formErrors: {}, // Add this to track validation errors
  selectedRoleID: "",  
  roleType: "",
  actionType: "",
};

const roleSlice = createSlice({
  name: "roleStepper",
  initialState,
  reducers: {
    setModules: (state, action) => {
      state.modules = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setFormErrors: (state, action) => {
      state.formErrors = action.payload; // Update form errors
    },
    setSelectedRoleID: (state, action) => {
      state.selectedRoleID = action.payload;
    },
    setRoleType: (state, action) => {
      state.roleType = action.payload;
    },
    setActionType: (state, action) => {
      state.actionType = action.payload;
    },
    resetFormData: (state) => {
      state.formData = { 
        name: "", 
        description: "", 
        type: "" 
      };
      state.formErrors = {}; // Reset form errors when resetting form data
    },
  },
});

export const { 
  setModules, 
  setFormData, 
  setFormErrors, 
  setSelectedRoleID, 
  setRoleType, 
  setActionType, 
  resetFormData 
} = roleSlice.actions;

export default roleSlice.reducer;